import React from 'react'
import { connect } from 'react-redux'
import { t } from 'ttag'
import { Link } from 'react-router-dom'
import { CSSTransitionGroup } from 'react-transition-group'
import { ReactBootstrapSlider } from 'react-bootstrap-slider'

import { logOccupationVideoView, videoListing } from '../../actions/occupationProfile'
import { updatePageTitle } from '../../actions/pageInfo'
import H2VideoPlayer from '../../components/H2VideoPlayer'
import * as h2Api from '../../h2Api'
import ActionButton from '../../components/ActionButton'
import { scrollToTopOfScreen } from '../../actions'

class VideoListing extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      start: 0,
      transitionLeft: false,
      filter: {
        jobZone: [1, 5],
        salary: [10000, 160000],
        cluster: '',
        flags: {},
        stem: false
      },
      selected: { id: 1, poster: '', caption: '', url: '', occupation: {} }
    }
  }

  componentDidMount() {
    this.props.dispatch(videoListing(this.state.start, this.filterToJson())).then(v => {
      if (v.data.length > 0) {
        const newState = {
          ...this.state,
          selected: v.data[0]
        }

        this.setState(newState)
      }
    })
    this.props.dispatch(updatePageTitle(t`Video Library`))
  }

  componentWillUnmount() {
    this.props.dispatch(updatePageTitle(null))
  }

  filter = () => {
    this.setState({ ...this.state, start: 0 })
    this.props.dispatch(videoListing(0, this.filterToJson()))
  }

  filterToJson = () => {
    const f = this.state.filter
    const filter = {
      jzMin: f.jobZone[0],
      jzMax: f.jobZone[1]
    }
    const flagKeys = Object.keys(f.flags)
    const selectedFlags = flagKeys.filter(k => f.flags[k])

    if (selectedFlags.length > 0) {
      filter.flags = selectedFlags
    }

    if (f.cluster != '') {
      filter.clusterId = f.cluster
    }

    if (f.salary[0] > 10000) {
      filter.salaryMin = f.salary[0]
    }

    if (f.salary[1] < 160000) {
      filter.salaryMax = f.salary[1]
    }

    return filter
  }

  videoSelect = result => e => {
    this.setState({
      ...this.state,
      selected: result
    })
    scrollToTopOfScreen()
  }

  page =
    (nextStart, isLeft = false) =>
    e => {
      this.setState({
        ...this.state,
        transitionLeft: isLeft,
        start: nextStart
      })
      this.props.dispatch(videoListing(nextStart, this.filterToJson()))
    }

  changeValue = key => v => {
    this.setState({
      ...this.state,
      filter: {
        ...this.state.filter,
        [key]: v.target.value
      }
    })
  }

  render = () => {
    const videoUrl = this.state.selected?.occupation?.url ?? '/'
    const wageState = this.state.selected.occupation?.wages?.stateName ?? 'n/a'
    const outlookState = this.state.selected.occupation?.outlook?.stateName ?? 'n/a'
    const minSalary = this.state.filter.salary[0].toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })
    const maxSalary = this.state.filter.salary[1].toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })
    const totalHits = this.props.videoListingRequest?.result?.totalHits
    const totalPages = Math.ceil(totalHits / 16)
    const currentPage = this.state.start + 1
    const isLoading = !h2Api.receivedResponse(this.props.videoListingRequest)
    const videoTitle = this.state.selected?.title ?? ''

    return (
      <div className="container" id="videos-container">
        <div id="videoHolder" className="text-center">
          <h2 id="videotitle">{t`Now Playing: ${videoTitle}`}</h2>
          <H2VideoPlayer
            aria-labelledby="videotitle"
            allowSeek={true}
            key={`vplayer--${this.state.selected?.onetSoc}`}
            id={`vplayer--${this.state.selected?.onetSoc}`}
            onComplete={() => {
              const sfn = this.state.selected?.occupation?.video?.url
              const fn = sfn.slice(sfn.lastIndexOf('/'))

              this.props.dispatch(
                logOccupationVideoView(this.state.selected?.onetSoc, fn)
              )
            }}
            poster={this.state.selected?.thumbNail}>
            <source type="video/mp4" src={this.state.selected?.occupation?.video?.url} />
            <track
              default
              kind="subtitles"
              srcLang="en"
              label="English"
              src={this.state.selected?.occupation?.video?.caption}
            />
          </H2VideoPlayer>
        </div>
        <div id="stats">
          <div className="boxed l" id="wagebox">
            <p>{t`In ${wageState}, the average wage was:`}</p>
            <div className="wage callout text-center">
              {this.state.selected?.occupation?.wages?.wage ?? 'n/a'}
            </div>
          </div>
          <div className="boxed r" id="projbox">
            <p>{t`In ${outlookState}, employment will increase annually by:`}</p>
            <div
              className={`outlook text-center callout ${
                this.state.selected?.occupation?.outlook?.employmentDirection
                  ? 'increasing'
                  : 'decreasing'
              }`}>
              {this.state.selected?.occupation?.outlook?.outlook ?? 'n/a'}
            </div>
          </div>
          {this.state.selected?.title && (
            <div id="actions">
              <div className="pull-right">
                {t`To get more information, `}&#160;
                <Link
                  to={videoUrl}
                  className="fullprofile pull-right"
                  style={{ textDecoration: 'underline' }}>
                  {t`view the profile for ${videoTitle}`}
                </Link>
              </div>
            </div>
          )}
        </div>

        <div id="filter" className="filter">
          <form>
            <fieldset className="row">
              <div className="col-xs-4">
                <label htmlFor="jobzone">{t`Job Zone is between ${this.state.filter.jobZone[0]} and ${this.state.filter.jobZone[1]}`}</label>
                <ReactBootstrapSlider
                  id={'jobzone'}
                  value={this.state.filter.jobZone}
                  change={this.changeValue('jobZone')}
                  step={1}
                  min={1}
                  tooltip="hide"
                  max={5}
                />
              </div>
              <div className="col-xs-4">
                <label htmlFor="salary">{t`Salary is between ${minSalary} and ${maxSalary}`}</label>
                <ReactBootstrapSlider
                  id={'salary'}
                  value={this.state.filter.salary}
                  change={this.changeValue('salary')}
                  step={1000}
                  min={10000}
                  tooltip="hide"
                  max={160000}
                />
              </div>
              <div className="col-xs-4">
                <label htmlFor="cluster-choose">{t`In ${dynamicValues.clusterTaxonomyTitle}`}</label>
                <select
                  id="cluster-choose"
                  className="form-control"
                  onBlur={this.changeValue('cluster')}>
                  <option value="">{t`Any of the ${dynamicValues.clusterTaxonomyTitle}`}</option>
                  {this.props.videoListingRequest?.result?.clusters?.map(c => (
                    <option value={c.id} key={c.id}>
                      {c.name}
                    </option>
                  ))}
                </select>
              </div>
              {this.props.videoListingRequest?.result?.flags?.map(f => (
                <div className="col-xs-4" key={f.id}>
                  <label title={f.description} htmlFor={f.id}>
                    {f.name} <span className={`listing-badge ${f.styleClass}`}></span>
                  </label>
                  <br />
                  <input
                    id={f.id}
                    type="checkbox"
                    value={this.state.filter.flags[f.id]}
                    onChange={v => (this.state.filter.flags[f.id] = v.target.checked)}
                  />
                </div>
              ))}
              <div className="nav">
                <ActionButton
                  className="btn btn-gray"
                  loading={this.props.videoListingRequest.loading}
                  error={this.props.videoListingRequest.error}
                  onClick={this.filter}
                  type="button">
                  {t`Filter`}
                </ActionButton>
              </div>
            </fieldset>
          </form>
        </div>

        <div id="listing">
          <h2>{t`Click a video below to play:`}</h2>
          <p
            className="text-center"
            style={{ fontWeight: 'bold' }}
            role="status"
            aria-live="polite">
            {t`${totalHits} videos found`}
          </p>
          <div
            style={{ display: isLoading ? 'block' : 'none' }}
            className="text-center alert alert-warning">
            <b>{t`Loading...`}</b>
          </div>
          <CSSTransitionGroup
            component="div"
            transitionName={this.state.transitionLeft ? 'h2animate-home' : 'h2animate'}
            transitionEnterTimeout={400}
            transitionLeaveTimeout={400}>
            {React.cloneElement(
              <ul style={{ opacity: isLoading ? '.2' : '1' }}>
                {this.props.videoListingRequest?.result?.data?.map(r => (
                  <li className="pic" key={r.onetSoc}>
                    <button onClick={this.videoSelect(r)}>
                      <div className="picwrapper">
                        <img
                          alt=""
                          src={r.thumbNail}
                          className="img-responsive"
                          name="thumbnail"
                        />
                      </div>
                      <span className="title">{r.title}</span>
                    </button>
                  </li>
                ))}
              </ul>,
              { key: `page.${this.state.start}--total.${totalHits}` }
            )}
          </CSSTransitionGroup>

          <br className="clear" />
          <div id="nav">
            <div className="col-xs-2">
              {this.state.start > 0 ? (
                <button
                  className="btn btn-gray"
                  onClick={this.page(Math.max(0, this.state.start - 1), true)}>
                  {t`Previous`}
                </button>
              ) : null}
            </div>
            <div className="col-xs-8 text-center">
              <span
                style={{
                  fontWeight: 'bold',
                  lineHeight: '50px'
                }}>
                {t`page ${currentPage} of ${totalPages} `}
              </span>
            </div>
            <div className="col-xs-2 text-right">
              {this.props.videoListingRequest?.result?.hasNext ? (
                <button
                  className="btn btn-gray"
                  onClick={this.page(this.state.start + 1)}>
                  {t`Next`}
                </button>
              ) : null}
            </div>
            <br className="clear" />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      ...state.occupations?.profile,
      videoListingRequest: state.occupations.videoListingRequest,
      videoDetailRequest: state.occupations.videoDetailRequest
    }
  },
  dispatch => ({
    dispatch
  })
)(VideoListing)
